
import Vue from "vue";
import Nav from "@/components/Nav.vue";
import Footerr from "@/components/Footerr.vue";

export default Vue.extend({
  name: "system",
  components: {
    Nav,
    Footerr,
  },
  data: () => ({
    fullSlider: 0,
    slidesNum: 5,
    items: [
      {
        id: 1,
        srcV: "https://www.youtube.com/embed/yJg-Y5byMMw",
        desc: "Lorem ipsum dolor sit amet",
      },
      {
        id: 1,
        srcV: "https://www.youtube.com/embed/yJg-Y5byMMw",
        desc: "Lorem ipsum dolor sit amet",
      },
      {
        id: 1,
        srcV: "https://www.youtube.com/embed/yJg-Y5byMMw",
        desc: "Lorem ipsum dolor sit amet",
      },
      {
        id: 1,
        srcV: "https://www.youtube.com/embed/yJg-Y5byMMw",
        desc: "Lorem ipsum dolor sit amet",
      },
    ],
  }),
  methods: {
    prev() {
      if (this.fullSlider <= 0) {
        this.fullSlider = this.slidesNum - 1;
      } else {
        this.fullSlider--;
      }
    },
    next() {
      if (this.fullSlider >= this.slidesNum - 1) {
        this.fullSlider = 0;
      } else {
        this.fullSlider++;
      }
    },
  },
});
